const normalizeBaseUrl = (value) => {
  const raw = (value || "").trim();
  return raw.endsWith("/") ? raw.slice(0, -1) : raw;
};

export function installApiAuthInterceptor({ apiBase, getToken }) {
  const normalizedApiBase = normalizeBaseUrl(apiBase);
  if (!normalizedApiBase || typeof window === "undefined" || window.__vpAuthFetchInstalled) {
    return;
  }

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const requestUrl = typeof input === "string" ? input : input?.url || "";
    if (!requestUrl.startsWith(normalizedApiBase)) {
      return originalFetch(input, init);
    }

    const token = (getToken && getToken()) || "";
    if (!token) {
      return originalFetch(input, init);
    }

    if (input instanceof Request) {
      if (input.headers.get("Authorization")) {
        return originalFetch(input, init);
      }
      const headers = new Headers(input.headers);
      headers.set("Authorization", `Bearer ${token}`);
      return originalFetch(new Request(input, { headers }), init);
    }

    const headers = new Headers((init && init.headers) || {});
    if (!headers.has("Authorization")) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return originalFetch(input, { ...(init || {}), headers });
  };

  window.__vpAuthFetchInstalled = true;
}